import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AssesmentResources from "./AssesmentResources"
import {getResources} from "../../../services/redux/Training/action";

const mapStateToProps = (state) => ({
    resources : state.Training.resources
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getResources
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(AssesmentResources);